import { t } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  grade: Yup.number().required(t('validation.class.gradeRequired')).nullable(),
  name: Yup.string().required(t('validation.class.nameRequired')),
  shortName: Yup.string().required(t('validation.class.shortNameRequired')),
  printPageNr: Yup.number()
    .typeError(t('validation.common.noNumber'))
    .integer(t('validation.common.integerOnly'))
    .moreThan(0, t('validation.common.greaterZero'))
    .notRequired(),
  printOrder: Yup.number()
    .typeError(t('validation.common.noNumber'))
    .integer(t('validation.common.integerOnly'))
    .moreThan(0, t('validation.common.greaterZero'))
    .notRequired(),
});
